export enum AuthorisationLevel {
  AuthorisedRepresentative = 0,
  Inactive = 1,
}
